import { render, staticRenderFns } from "./BorderLayer.vue?vue&type=template&id=005f3a88&"
import script from "./BorderLayer.vue?vue&type=script&lang=js&"
export * from "./BorderLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports